import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import InputTextNested from '../../Components/Form/InputTextNested';
import {
  InputSection,
  UserSettingsSection,
  TitleSection,
} from './UserSettingsStyles.styles';

const NameDetails = ({ user, setUser }) => {
  return (
    <UserSettingsSection>
      {/* For first name and last name */}
      <TitleSection>
        <h4>Name</h4>
        <span className="italicSpan">
          The name displayed here is what will appear on your certificate
        </span>
      </TitleSection>
      <InputSection>
        <Suspense fallback={<div>Loading input...</div>}>
          <InputTextNested
            title="First Name"
            value={user?.firstName}
            name="firstName"
            nestedValue={setUser}
            upperValue={user}
            className="gapIt"
          />
          <InputTextNested
            title="Last Name"
            value={user?.lastName}
            name="lastName"
            nestedValue={setUser}
            upperValue={user}
            className="gapIt"
          />
        </Suspense>
      </InputSection>
    </UserSettingsSection>
  );
};

NameDetails.propTypes = {
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  setUser: PropTypes.func,
};

export default NameDetails;
